import { render, staticRenderFns } from "./editComment.vue?vue&type=template&id=e759c254&scoped=true&"
import script from "./editComment.vue?vue&type=script&lang=js&"
export * from "./editComment.vue?vue&type=script&lang=js&"
import style0 from "./editComment.vue?vue&type=style&index=0&id=e759c254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e759c254",
  null
  
)

export default component.exports